/**
 * Sample data driving the Invite Teammates page until the licensing/invite
 * tables are migrated. Mirrors the pattern in `teamsSample.ts`.
 *
 * The sample summary is intentionally sized so reviewers can exercise both
 * "headroom" and "near-full pool" UI states without touching the schema:
 *
 *   - Leader pool: 3/5 used  → invite leaders, see counter tick, hit cap.
 *   - Staff pool:  28/40 used → invite teachers/support, see counter tick.
 */
import type { LicenseSummary, PendingInvite } from "@/types/inviteTeammates";
import { SAMPLE_DISTRICT_NAME, SAMPLE_DISTRICT_SCHOOLS, SAMPLE_SCHOOL_TEAM_SNAPSHOT } from "./teamsSample";

export const SAMPLE_SCHOOL_LICENSE_SUMMARY: LicenseSummary = {
  districtId: null,
  schoolId: SAMPLE_SCHOOL_TEAM_SNAPSHOT.schoolId,
  scopeLabel: SAMPLE_SCHOOL_TEAM_SNAPSHOT.schoolName,
  pools: {
    leader: { total: 5, used: 3 },
    staff: { total: 40, used: 28 },
  },
};

export const SAMPLE_DISTRICT_LICENSE_SUMMARY: LicenseSummary = {
  districtId: "sample-district",
  schoolId: null,
  scopeLabel: SAMPLE_DISTRICT_NAME,
  pools: {
    leader: { total: 12, used: 7 },
    staff: { total: 220, used: 167 },
  },
};

export const SAMPLE_PENDING_INVITES: PendingInvite[] = [
  {
    id: "sample-invite-1",
    email: "morgan.lee@example.org",
    role: "teacher",
    schoolId: SAMPLE_SCHOOL_TEAM_SNAPSHOT.schoolId,
    schoolName: SAMPLE_SCHOOL_TEAM_SNAPSHOT.schoolName,
    status: "pending",
    sentAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 2).toISOString(),
    invitedByEmail: "leader@example.org",
  },
  {
    id: "sample-invite-2",
    email: "alex.rivera@example.org",
    role: "support_staff",
    schoolId: SAMPLE_SCHOOL_TEAM_SNAPSHOT.schoolId,
    schoolName: SAMPLE_SCHOOL_TEAM_SNAPSHOT.schoolName,
    status: "pending",
    sentAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 5).toISOString(),
    invitedByEmail: "leader@example.org",
  },
  {
    id: "sample-invite-3",
    email: "principal.kim@example.org",
    role: "leader",
    schoolId: SAMPLE_DISTRICT_SCHOOLS[1]?.schoolId ?? SAMPLE_SCHOOL_TEAM_SNAPSHOT.schoolId,
    schoolName:
      SAMPLE_DISTRICT_SCHOOLS[1]?.schoolName ?? SAMPLE_SCHOOL_TEAM_SNAPSHOT.schoolName,
    status: "pending",
    sentAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 9).toISOString(),
    invitedByEmail: "superintendent@example.org",
  },
];
